import { render } from "./MessageVideo.vue?vue&type=template&id=046195df&scoped=true&ts=true"
import script from "./MessageVideo.vue?vue&type=script&lang=ts"
export * from "./MessageVideo.vue?vue&type=script&lang=ts"

import "./MessageVideo.vue?vue&type=style&index=0&id=046195df&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046195df"]])

export default __exports__